<template>
  <v-container fill-height style="min-height: calc(100vh - 70px - 84px);">
    <notifications class="pa-3"/>
    <v-row>
      <v-col cols="12" md="7">
        <div>
          <h2 class="text-md-h5">
            Buku Tamu PNB
          </h2>
          <p>
            Selamat datang di Politeknik Negeri Bali
          </p>
        </div>
        <v-form
          @submit.prevent="submitAddData"
          ref="formadddata"
          v-model="formupdate.valid"
          lazy-validation>
          <v-row justify="center">
            <v-col cols="12">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="adddata.nama"
                    label="Nama *"
                    name="nama"
                    :rules="[rules.required]">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="adddata.perihal"
                    label="Perihal *"
                    name="perihal"
                    :rules="[rules.required]">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="adddata.pekerjaan"
                    label="Pekerjaan *"
                    name="pekerjaan"
                    :rules="[rules.required]">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="adddata.bertemu"
                    label="Ingin Bertemu *"
                    name="bertemu"
                    :rules="[rules.required]">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" class="text-center">
                  <alertsp :alertdata="alertdata"></alertsp>
                  <v-btn
                    large
                    block
                    :loading="loading.tiket"
                    :disabled="loading.tiket || !formupdate.valid"
                    color="primary"
                    class="mt-5"
                    type="submit">
                    Simpan & Kembali
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown">
        <!-- <v-divider vertical></v-divider> -->
      </v-col>
      <v-col cols="12" md="4">
        <div>
          <h2 class="text-md-h5">
            QR Code Buku Tamu
          </h2>
          <p>
            Gunakan QR Code untuk mengisi Buku Buku Tamu.
          </p>
        </div>
        <div>
          <img :src="require('../../assets/qr-bukutamu.png')" height="300"/>
        </div>
      </v-col>
    </v-row>
    <!-- modal loading -->
    <v-dialog
      v-model="dmodal.loading"
      persistent
      width="300">
      <v-card>
        <v-card-text class="pt-6">
          <div v-if="loading.tiket">
            Please stand by
            <v-progress-linear
              indeterminate>
            </v-progress-linear>
          </div>
          <div v-if="dmodal.image" class="text-center">
            <img :src="require('../../assets/suksma.png')" width="120"/>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import thankSound from '@/assets/thankyou.mp3';

export default {
  name: 'Bukutamu',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      contact: false,
      regnew: false,
      tiket: false,
    },
    formupdate: {
      valid: false,
    },
    api: process.env.VUE_APP_API,
    apptitle: process.env.VUE_APP_TITLE,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      tgllahir: false,
    },
    publickey: '123',
    contact: {
      name: '',
      email: '',
      subject: '',
      message: '',
    },
    formin: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v.length >= 16 || v === 'majujaya') || 'Min 16 characters',
      phone: (v) => (!!v && v.length <= 12) || 'Max 12 characters',
      email: [
        (v) => !!v || 'E-mail is required',
        (v) => (!!v && /.+@.+\..+/.test(v)) || 'E-mail must be valid',
      ],
      files: [
        (value) => !value || value.size < 1000000 || 'File kurang dari 1 MB!',
        (value) => !!value || 'Required.',
      ],
    },
    word: 'Vue',
    thankSound,
    listbertemu: ['Direktur', 'Wakil Direktur 1', 'Wakil Direktur 2', 'lainnya'],
    listtujuan: ['Institusi', 'Studi Banding', 'Tugas', 'lainnya'],
    listwisman: [
      {
        label: 'Domestik',
        value: 0,
      },
      {
        label: 'Mancanegara',
        value: 1,
      },
    ],
    adddata: {
      perihal: '',
      bertemu: '',
      pekerjaan: '',
      nama: '',
    },
    dmodal: {
      register: false,
      tiket: false,
      loading: false,
      image: false,
    },
    dmodaldata: {
      tiket: null,
    },
    regflag: false,
    datares: '',
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  watch: {
    'datepick.tgllahir'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
  },
  created: () => ({
  }),
  mounted() {
    // console.log('1');
  },
  methods: {
    redirectDetail(direction, delay) {
      const thisVue = this;
      setTimeout(() => (thisVue.$router.push(direction)), delay);
    },
    submitAddData() {
      this.alertdata.show = false;
      if (this.$refs.formadddata.validate()) {
        const notifdata = {
          title: 'Notifikasi Bukutamu',
          text: '',
          type: 'warm',
        };
        this.dmodal.loading = true;
        this.dmodal.image = false;
        this.loading.tiket = true;
        this.datares = '';
        this.axios
          .post(
            this.api + '/public/bukutamu',
            qs.stringify(
              this.adddata,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            // this.alertdata.show = true;
            this.dmodal.loading = false;
            this.loading.tiket = false;
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                // show image
                this.dmodal.loading = true;
                this.dmodal.image = true;
                // play sound
                const note = new Audio(this.thankSound);
                setTimeout(() => {
                  note.play();
                }, 500);
                // wait - 4 second - close
                setTimeout(() => {
                  this.dmodal.loading = false;
                  this.dmodal.image = false;
                  this.redirectDetail({ name: 'Index' }, 1000);
                }, 4000);
                // notif
                notifdata.type = 'success';
                notifdata.text = 'Terimakasih!';
                // this.alertdata.type = 'success';
                // this.alertdata.text = 'Thank you!';
                // this.datares = resdata.data;
              } else {
                notifdata.type = 'error';
                notifdata.text = resdata.message;
                // this.alertdata.type = 'error';
                // this.alertdata.text = resdata.message;
              }
            } else {
              notifdata.type = 'error';
              notifdata.text = 'Internal services error!';
              // this.alertdata.type = 'error';
              // this.alertdata.text = 'Internal services error!';
            }
            this.$notify(notifdata);
          })
          .catch((error) => {
            console.log(error);
            notifdata.type = 'error';
            notifdata.text = 'Internal services error!';
            this.$notify(notifdata);
            // this.alertdata.show = true;
            // this.alertdata.type = 'error';
            // this.alertdata.text = 'Internal services error!';
            this.loading.tiket = false;
            this.dmodal.loading = false;
          });
      }
    },
    printTiket(data) {
      console.log('print');
      console.log(data);
      console.log(this.adddata);
      this.$htmlToPaper('printMe');
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
